import { render, staticRenderFns } from "./FormModalNote.vue?vue&type=template&id=52b57a4f&"
import script from "./FormModalNote.vue?vue&type=script&lang=js&"
export * from "./FormModalNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports